import {
  ApplicationConfig,
  provideZonelessChangeDetection,
  isDevMode,
  importProvidersFrom,
} from '@angular/core';
import { provideRouter, withRouterConfig } from '@angular/router';
import { provideAuth0 } from '@auth0/auth0-angular';
import { provideHttpClient } from '@angular/common/http';
import { DialogService } from 'primeng/dynamicdialog';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideAngularSvgIcon } from 'angular-svg-icon';
import { ConfirmationService, MessageService } from 'primeng/api';
import { providePrimeNG } from 'primeng/config';
import { environment } from '../environments/environment';
import { BlindspotPreset } from '../styles/preset';
import { routes } from './app.routes';
import { TranslocoHttpLoader } from './transloco-loader';
import { provideTransloco } from '@jsverse/transloco';
import { provideTranslocoMessageformat } from '@jsverse/transloco-messageformat';
import { provideTranslocoLocale } from '@jsverse/transloco-locale';
import { MsalModule } from '@azure/msal-angular';
import { PublicClientApplication, InteractionType } from '@azure/msal-browser';

export const appConfig: ApplicationConfig = {
  providers: [
    provideHttpClient(),
    provideZonelessChangeDetection(),
    provideRouter(
      routes,
      withRouterConfig({ paramsInheritanceStrategy: 'always' }),
    ),
    provideAuth0(environment.auth0),
    provideAnimations(),
    providePrimeNG({
      theme: {
        preset: BlindspotPreset,
        options: {
          // .dark is set on the html element, so dark mode is always enabled.
          darkModeSelector: '.dark',
        },
      },
    }),
    provideAngularSvgIcon(),
    MessageService,
    DialogService,
    ConfirmationService,
    importProvidersFrom(
      MsalModule.forRoot(
        new PublicClientApplication({
          auth: {
            clientId: environment.microsoft.clientId,
            authority: `https://login.microsoftonline.com/common`,
            redirectUri: `${window.location.origin}/auth-redirect.html`,
            postLogoutRedirectUri: `${window.location.origin}/auth-redirect.html`,
          },
        }),
        {
          interactionType: InteractionType.Popup,
          authRequest: {
            scopes: ['https://graph.microsoft.com/Calendars.ReadWrite'],
          },
        },
        {
          interactionType: InteractionType.Popup,
          protectedResourceMap: new Map([
            [
              'https://graph.microsoft.com/v1.0/',
              ['https://graph.microsoft.com/Calendars.ReadWrite'],
            ],
          ]),
        },
      ),
    ),
    provideTransloco({
      config: {
        availableLangs: ['en', 'fr', 'nl'],
        defaultLang: 'en',
        reRenderOnLangChange: true,
        prodMode: !isDevMode(),
      },
      loader: TranslocoHttpLoader,
    }),
    provideTranslocoMessageformat({
      locales: ['en', 'fr', 'nl'],
    }),
    provideTranslocoLocale({
      langToLocaleMapping: {
        en: 'en-US',
        fr: 'fr-FR',
        nl: 'nl-NL',
      },
    }),
  ],
};
